import { BusinessCenter, Delete, PauseCircle } from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

interface EmptyStateProps {
  type: 'added' | 'suspended' | 'deleted';
}

const EmptyState: React.FC<EmptyStateProps> = ({ type }) => {
  const getEmptyStateConfig = () => {
    switch (type) {
      case 'added':
        return {
          icon: (
            <BusinessCenter sx={{ fontSize: 64, color: 'text.secondary' }} />
          ),
          title: 'No hay empresas agregadas',
          description: 'Comienza agregando tu primera empresa.',
        };
      case 'suspended':
        return {
          icon: <PauseCircle sx={{ fontSize: 64, color: 'warning.main' }} />,
          title: 'No hay empresas por eliminar',
          description:
            'No tienes empresas con cancelación efectiva al cierre de ciclo en este momento.',
        };
      case 'deleted':
        return {
          icon: <Delete sx={{ fontSize: 64, color: 'error.main' }} />,
          title: 'No hay empresas eliminadas',
          description: 'No tienes empresas eliminadas en este momento.',
        };
      default:
        return {
          icon: (
            <BusinessCenter sx={{ fontSize: 64, color: 'text.secondary' }} />
          ),
          title: 'No hay datos disponibles',
          description: 'No se encontraron datos para mostrar.',
        };
    }
  };

  const config = getEmptyStateConfig();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 6,
        textAlign: 'center',
        backgroundColor: 'grey.50',
        borderRadius: 2,
        border: '1px dashed',
        borderColor: 'grey.300',
      }}
    >
      <Box sx={{ mb: 3 }}>{config.icon}</Box>
      <Typography
        variant="h6"
        component="h3"
        gutterBottom
        sx={{ color: 'text.primary', fontWeight: 500 }}
      >
        {config.title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 400, mx: 'auto' }}
      >
        {config.description}
      </Typography>
    </Paper>
  );
};

export default EmptyState;
